/**
 * Replaces the space after a single-letter conjunction with a non-breaking
 * space (\u00A0) to prevent typographic widows at line breaks.
 *
 * Handles conjunctions at the start of the string, after any whitespace, and
 * after newline characters. Only applies to Polish and Italian; all other
 * languages are returned unchanged.
 *
 * Mental test (PL):
 *   'W małym mieście'  → 'W\u00A0małym mieście'   (start-of-string)
 *   'Idź w lewo'       → 'Idź w\u00A0lewo'         (mid-sentence)
 *   'kot i pies'       → 'kot i\u00A0pies'          (mid-sentence)
 */
export function fixHangingConjunctions(text, lang) {
  if (lang === 'PL') {
    // Polish single-letter conjunctions: w, i, z, o, a, u
    return text.replace(/(^|\s)([wizoau])\s/gi, '$1$2\u00A0');
  }
  if (lang === 'IT') {
    // Italian single-letter conjunctions: e, o, a, i, u
    return text.replace(/(^|\s)([eoaiu])\s/gi, '$1$2\u00A0');
  }
  return text;
}
